import { render, staticRenderFns } from "./MapPolygonModal.vue?vue&type=template&id=632cc36d&"
import script from "./MapPolygonModal.vue?vue&type=script&lang=js&"
export * from "./MapPolygonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports